/**
 * Locale scaffold. The panel ships Turkish-only today; this module
 * exists so the language-selector, cookie reader, and any future
 * dictionary loader share one source of truth.
 *
 * When a translation backend lands (whether a dictionary object, an
 * external service, or `next-intl`), it consumes `Locale` from here.
 */

export const SUPPORTED_LOCALES = ['tr', 'en'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'tr';

export interface LocaleDescriptor {
  readonly code: Locale;
  readonly nativeName: string;
  readonly englishName: string;
}

export const LOCALE_REGISTRY: Readonly<Record<Locale, LocaleDescriptor>> = Object.freeze({
  tr: { code: 'tr', nativeName: 'Türkçe', englishName: 'Turkish' },
  en: { code: 'en', nativeName: 'English', englishName: 'English' },
});

export function isLocale(value: string): value is Locale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value);
}
